import { FormatedDate } from '@common/components/FormatedDate';
import { TableCard } from '@features/tableEngine/components';
import { formatTime } from '@common/utils/formatTime';
import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { useSelectedClipWorkflows } from '../hooks';
import { WorkflowEntry } from '../types/workflow';

const pageSizes = [...Array(5)].map((_, i) => (i + 1) * 10);

export const HistorySection = () => {
    const { t } = useTranslation('workflowTable');

    const result = useSelectedClipWorkflows({
        pageIndex: 0,
        pageSize: pageSizes[0],
        sorting: [{ id: 'created', desc: true }],
    });

    const columns: ColumnDef<WorkflowEntry>[] = [
        {
            accessorKey: 'id',
            header: t('header.id'),
            enableResizing: false,
            meta: {
                defaultHidden: true,
            },
        },
        {
            accessorKey: 'created',
            header: t('header.created'),
            cell: ({ cell }) => {
                const date = cell.getValue() as number;
                return (
                    <FormatedDate
                        date={date}
                        options={{
                            timeStyle: 'long',
                            dateStyle: 'short',
                        }}
                    />
                );
            },
        },
        {
            accessorKey: 'label',
            header: t('header.label'),
        },

        {
            accessorKey: 'status',
            header: t('header.status'),
        },

        {
            accessorKey: 'updated',
            header: t('header.updated'),
            cell: ({ cell }) => {
                const date = cell.getValue() as number;
                return (
                    <FormatedDate
                        date={date}
                        options={{
                            timeStyle: 'long',
                            dateStyle: 'short',
                        }}
                    />
                );
            },
        },
        {
            accessorKey: 'completed',
            header: t('header.completed'),
            cell: ({ cell }) => {
                const date = cell.getValue() as number;
                return (
                    <FormatedDate
                        date={date}
                        options={{
                            timeStyle: 'long',
                            dateStyle: 'short',
                        }}
                    />
                );
            },
        },
        {
            accessorKey: 'duration',
            header: t('header.duration'),
            cell: ({ cell }) => formatTime(cell.getValue() as number),
        },
    ];

    return (
        <TableCard
            config={{
                title: t('title'),
                search: {
                    enabled: false,
                    // placeholder: t('search.placeholder'),
                },
                columns,
            }}
            {...result}
        />
    );
};
